@if (!loading && !botonBLE) {
  <app-breadcrumb
    listado="/main/administracion/botones-ble"
    etiquetaListado="Botones BLE"
    [titulo]="botonBLE?.mac"
  ></app-breadcrumb>
  <app-empty-state
    icon="touch_app"
    message="No se encontró el botón"
  ></app-empty-state>
} @else if (!loading && botonBLE) {
  <app-breadcrumb
    listado="/main/administracion/botones-ble"
    etiquetaListado="Botones BLE"
    [titulo]="botonBLE?.mac"
  ></app-breadcrumb>

  <!-- Encabezado con la misma estética que las tarjetas de la pestaña Info.
       Sin Editar: el listado tampoco lo tiene. -->
  <header class="encabezado">
    <div class="encabezado-avatar"><mat-icon>touch_app</mat-icon></div>
    <div class="encabezado-texto">
      <h1 class="ble-mac">{{ botonBLE.mac }}</h1>
      @if (botonBLE.serialNumber) {
        <span class="encabezado-nombre">{{ botonBLE.serialNumber }}</span>
      }
      <div class="encabezado-chips">
        @if (botonBLE.cliente?.nombre) {
          <span class="chip">
            <mat-icon>business</mat-icon>
            {{ botonBLE.cliente.nombre }}
          </span>
        }
      </div>
    </div>
  </header>

  <mat-tab-group
    [(selectedIndex)]="selectedTab"
    (selectedTabChange)="tabChanged($event)"
    class="tabs-detalle"
  >
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">info</mat-icon>
        <span>Info</span>
      </ng-template>
      <ng-template matTabContent>
        <app-detalles-boton-ble-info
          [botonBLE]="botonBLE"
        ></app-detalles-boton-ble-info>
      </ng-template>
    </mat-tab>

    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">crisis_alert</mat-icon>
        <span>Alertas</span>
      </ng-template>
      <ng-template matTabContent>
        <app-alertas-boton-ble [mac]="botonBLE.mac"></app-alertas-boton-ble>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
} @else {
  <app-detalle-esqueleto
    icono="touch_app"
    listado="/main/administracion/botones-ble"
    etiquetaListado="Botones BLE"
    [pestanas]="2"
  ></app-detalle-esqueleto>
}
